import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "container",
  class: "device-status-display"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeslots, (timeslot) => {
      return (_openBlock(), _createBlock(_component_n_tooltip, {
        key: timeslot?.id,
        trigger: "hover"
      }, {
        trigger: _withCtx(() => [
          _createElementVNode("div", {
            class: "timeslot",
            style: _normalizeStyle({ width: _ctx.slotWidth, backgroundColor: _ctx.getColor(timeslot) })
          }, null, 4 /* STYLE */)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(timeslot?.start.format('LL')), 1 /* TEXT */)
        ]),
        _: 2 /* DYNAMIC */
      }, 1024 /* DYNAMIC_SLOTS */))
    }), 128 /* KEYED_FRAGMENT */))
  ], 512 /* NEED_PATCH */))
}